<template>
  <div class="box">
    <div class="title">
      <h1>生&nbsp;产&nbsp;任&nbsp;务&nbsp;书</h1>
    </div>
    <div class="tab1 tab">
      <table
        cellspacing="0"
        cellpadding="10"
        v-for="(item, index) in list"
        :key="index"
      >
        <tr>
          <th>任务书号</th>
          <td>{{ item.TaskNo }}</td>
          <th>产品型号</th>
          <td colspan="3">{{ item.PRODUCTID }}</td>
          <th>机台号</th>
          <td>{{ item.WEAVDEVICEID }}</td>
        </tr>
        <tr>
          <th>整经计划号</th>
          <td>{{ item.BeamCardNo }}</td>
          <th>订单号</th>
          <td colspan="3">{{ item.ORDERID }}</td>
          <th>订单门幅</th>
          <td>{{ item.GATEWIDTH }}</td>
        </tr>
        <tr>
          <th>经轴数量</th>
          <td>{{ item.BEAMLENGTH }}</td>
          <th>产品米数</th>
          <td colspan="3">{{ item.QUANTITY }}</td>
          <th>匹数</th>
          <td>{{ item.ROLLNUM }}</td>
        </tr>
        <tr>
          <th>上机纬密</th>
          <td>{{ item.UPWEFT }}</td>
          <th>筘号</th>
          <td>{{ item.KOUHAO }}</td>
          <th>成品克重</th>
          <td>{{ item.PRODUCTHEAVY }}</td>
          <th>经线排列</th>
          <td>{{ item.WARPARRAY }}</td>
        </tr>
        <tr>
          <th>轴幅</th>
          <td colspan="5">{{ item.BEAMRANGE }}</td>
          <th>纬线排列</th>
          <td>{{ item.WEFTARRAY }}</td>
        </tr>
        <tr>
          <th>纹板说明</th>
          <td colspan="5">{{ item.WENBANART }}</td>
          <th>完成日期</th>
          <td>{{ item.PLANTIME }}</td>
        </tr>
        <tr>
          <th>生产工艺</th>
          <td colspan="7">{{ item.ReMark }}</td>
        </tr>
      </table>
    </div>
    <div class="title">
      <h1>工<span style="color: #eee">工艺</span>艺</h1>
    </div>
    <div class="tab2 tab">
      <table
        cellspacing="0"
        cellpadding="10"
        v-for="(item, index) in gongyiList"
        :key="index"
      >
        <tr>
          <th rowspan="3">机上规格</th>
          <th>项目</th>
          <th>外筘</th>
          <th>内筘</th>
          <th colspan="2">筘号</th>
          <th colspan="3">每筘齿穿入数</th>
          <th colspan="2">纬 密</th>
        </tr>
        <tr>
          <th>单位</th>
          <td>cm</td>
          <td>cm</td>
          <td colspan="2">齿/cm</td>
          <td colspan="3">根</td>
          <td colspan="2">根/cm</td>
        </tr>
        <tr>
          <th>规格</th>
          <td>{{ item.TOTALKOUFU }}</td>
          <td>{{ item.REEDINSHEET }}</td>
          <td colspan="2">{{ item.KOUHAO }}</td>
          <td colspan="3">{{ item.INWARPINTO }}</td>
          <td colspan="2">{{ item.WEFTTOOTH }}</td>
        </tr>
        <tr>
          <th rowspan="2" style="border-bottom: 0">纬线放置</th>
          <th>选纬针</th>
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
        </tr>
        <tr>
          <th>纬线</th>
          <td>{{ WEFTARRAYLIST[0] }}</td>
          <td>{{ WEFTARRAYLIST[1] }}</td>
          <td>{{ WEFTARRAYLIST[2] }}</td>
          <td>{{ WEFTARRAYLIST[3] }}</td>
          <td>{{ WEFTARRAYLIST[4] }}</td>
          <td>{{ WEFTARRAYLIST[5] }}</td>
          <td>{{ WEFTARRAYLIST[6] }}</td>
          <td>{{ WEFTARRAYLIST[7] }}</td>
          <td>{{ WEFTARRAYLIST[8] }}</td>
        </tr>
      </table>
    </div>
    <div class="title">
      <h1>经<span style="color: #eee">经纱</span>纱</h1>
    </div>
    <div class="tab4 tab">
      <el-table
        :data="objs.weavPlanDetailList2"
        border
        stripe
        height="86"
        size="mini"
      >
        <el-table-column prop="SERIALNO" label="序号"> </el-table-column>
        <el-table-column prop="MATERIALID" label="原料编号"> </el-table-column>
        <el-table-column prop="SUBBATCHNO" label="明细单号"> </el-table-column>
        <el-table-column prop="INSTOCKDATE" label="入库日期"> </el-table-column>
        <el-table-column prop="COLORNAME" label="色别"> </el-table-column>
        <el-table-column prop="NEEDQUANTITY" label="需要数量">
        </el-table-column>
        <el-table-column prop="DAYNEED" label="日需数量"> </el-table-column>
        <el-table-column prop="FACTLEADQUANTITY" label="已领数量">
        </el-table-column>
        <el-table-column prop="REMARK" label="备注"> </el-table-column>
      </el-table>
    </div>
    <div class="title">
      <h1>纬<span style="color: #eee">纬纱</span>纱</h1>
    </div>
    <div class="tab4 tab">
      <el-table
        :data="objs.weavPlanDetailList"
        border
        stripe
        height="86"
        size="mini"
      >
        <el-table-column prop="SERIALNO" label="序号"> </el-table-column>
        <el-table-column prop="MATERIALID" label="原料编号"> </el-table-column>
        <el-table-column prop="SUBBATCHNO" label="明细单号"> </el-table-column>
        <el-table-column prop="INSTOCKDATE" label="入库日期"> </el-table-column>
        <el-table-column prop="COLORNAME" label="色别"> </el-table-column>
        <el-table-column prop="NEEDQUANTITY" label="需要数量">
        </el-table-column>
        <el-table-column prop="DAYNEED" label="日需数量"> </el-table-column>
        <el-table-column prop="FACTLEADQUANTITY" label="已领数量">
        </el-table-column>
        <el-table-column prop="REMARK" label="备注"> </el-table-column>
      </el-table>
    </div>
    <div class="btns">
      <el-button type="danger" size="mini" @click="back">返回</el-button>
    </div>
  </div>
</template>
<script>
import { api } from "../../api";
import localStorage from "../../api/localStorage";
export default {
  data() {
    return {
      list: [], // 主数据\
      gongyiList: [],
      WEFTARRAYLIST: [],
      weaving: "", // 经轴号
      store: "", // 仓库
      storeList: [],
      localStore: "", // 库位
      localStoreList: [],
      user: localStorage.getUser(),
      objs: {},
      index: 1,
      pObjs: {},
    };
  },
  created() {
    this.pObjs = JSON.parse(this.$route.query.pObjs);
    this.getList();
  },
  methods: {
    //   主数据
    getList() {
      console.log(this.pObjs.WEAVNO);
      api.GetWeavPlan(this.pObjs.WEAVNO).then((res) => {
        console.log(res.data);
        // if (res.data.Success) {
        this.objs = res.data;
        this.list = [
          {
            index: this.index++,
            TaskNo: this.objs.TaskNo,
            PRODUCTID: this.objs.PRODUCTID,
            WEAVDEVICEID: this.objs.WEAVDEVICEID,
            BeamCardNo: this.objs.BeamCardNo,
            ORDERID: this.objs.ORDERID,
            GATEWIDTH: this.objs.GATEWIDTH,
            TaskNo: this.objs.TaskNo,
            BEAMLENGTH: this.objs.BEAMLENGTH,
            QUANTITY: this.objs.QUANTITY,
            ROLLNUM: this.objs.ROLLNUM,
            UPWEFT: this.objs.UPWEFT,
            KOUHAO: this.objs.KOUHAO,
            PRODUCTHEAVY: this.objs.PRODUCTHEAVY,
            WARPARRAY: this.objs.WARPARRAY,
            BEAMRANGE: this.objs.BEAMRANGE,
            WEFTARRAY: this.objs.WEFTARRAY,
            WENBANART: this.objs.WENBANART,
            PLANTIME: this.objs.PLANTIME,
            ReMark: this.objs.ReMark,
          },
        ];
        this.gongyiList = [
          {
            index: this.index++,
            TOTALKOUFU: this.objs.TOTALKOUFU,
            REEDINSHEET: this.objs.REEDINSHEET,
            KOUHAO: this.objs.KOUHAO,
            INWARPINTO: this.objs.INWARPINTO,
            WEFTTOOTH: this.objs.WEFTTOOTH,
          },
        ];
        this.WEFTARRAYLIST = this.objs.WEFTARRAYLIST;
      });
    },
    back() {
      // window.localStorage.clear()
      this.$router.push({
        path: "/zhizao",
      });
    },
  },
};
</script>
<style>
.el-table {
  color: #737373;
  font-size: 8px;
  /* padding: 8px; */
}

.el-table thead {
  color: #323232 !important;
  font-weight: 100;
  font-size: 10px;
  background: #f8f8f8;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #d9d9d9;
  padding: 0;
}

.el-table td.is-leaf:last-child {
  border-right: 0;
}

.el-table th.is-leaf:last-child {
  border-right: 0;
}
</style>
</style>
<style lang="less" scoped>
@deep: ~">>>";

.box {
  height: 100vh;
  padding: 8px;
  box-sizing: border-box;
  overflow: hidden;
  background: #eee;
  border: 1px solid #cecece;
  position: relative;
  overflow-y: scroll;
  @{deep} .el-input--suffix {
    width: 100% !important;
  }
  .title {
    h1 {
      font-size: 0.28rem;
      font-weight: 600;
      line-height: 0.28rem;
      text-align: center;
    }
  }
  .tab {
    /* width: 100%; */
    margin: 5px auto;
    border: 1px solid #cecece;
    background: #fff;
    /* 
    @{deep}.el-button--mini {
      font-size: 8px;
      color: #f34b53;
    } */
  }

  .btns {
    width: 100%;
    position: absolute;
    bottom: 5px;
    height: 0.6rem;
    text-align: center;
    line-height: 0.6rem;
  }
  .el-button--mini,
  .el-button {
    padding: 0.14rem 0.4rem !important;
    font-size: 0.25rem;
  }

  @{deep} .el-table .cell {
    text-align: center;
    height: 0.5rem;
    line-height: 0.5rem;
  }

  @{deep}.el-table--mini td,
  .el-table--mini th {
    padding: 0 !important;
  }
  .tab2,
  .tab1 {
    width: 100%;
    table {
      width: 100%;
      // height: 100%;
      border: 1px;

      tr {
        width: 100%;
        height: 0.45rem;
        line-height: 0.45rem;
        th,
        td {
          width: 0.083%;
          height: 0.45rem;
          line-height: 0.45rem;
          border-right: 0.02667rem solid #d9d9d9;
          border-bottom: 0.02667rem solid #d9d9d9;
          text-align: center;
        }
      }
      td:last-child,
      th:last-child {
        border-right: 0;
      }
      tr:last-child {
        td,
        th {
          border-bottom: 0;
        }
      }
    }
  }
}
</style>